var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrival({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 94,
    height: 91,
    viewBox: "0 0 94 91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10267",
    "data-name": "Group 10267",
    transform: "translate(0.099)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_47",
    "data-name": "Path 47",
    transform: "translate(-0.099)",
    fill: "#ffd200"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81 90.25 L 13 90.25 C 9.727912902832031 90.25 6.651662349700928 88.97577667236328 4.337937355041504 86.66206359863281 C 2.024224996566772 84.34833526611328 0.75 81.27208709716797 0.75 78 L 0.75 13 C 0.75 9.727912902832031 2.024224996566772 6.651662349700928 4.337937355041504 4.337937355041504 C 6.651662349700928 2.024224996566772 9.727912902832031 0.75 13 0.75 L 81 0.75 C 84.27208709716797 0.75 87.34833526611328 2.024224996566772 89.66206359863281 4.337937355041504 C 91.97577667236328 6.651662349700928 93.25 9.727912902832031 93.25 13 L 93.25 78 C 93.25 81.27208709716797 91.97577667236328 84.34833526611328 89.66206359863281 86.66206359863281 C 87.34833526611328 88.97577667236328 84.27208709716797 90.25 81 90.25 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13 1.5 C 9.928237915039062 1.5 7.040336608886719 2.696212768554688 4.868263244628906 4.868263244628906 C 2.696212768554688 7.040336608886719 1.5 9.928237915039062 1.5 13 L 1.5 78 C 1.5 81.07176208496094 2.696212768554688 83.95966339111328 4.868263244628906 86.13173675537109 C 7.040336608886719 88.30378723144531 9.928237915039062 89.5 13 89.5 L 81 89.5 C 84.07176208496094 89.5 86.95966339111328 88.30378723144531 89.13173675537109 86.13173675537109 C 91.30378723144531 83.95966339111328 92.5 81.07176208496094 92.5 78 L 92.5 13 C 92.5 9.928237915039062 91.30378723144531 7.040336608886719 89.13173675537109 4.868263244628906 C 86.95966339111328 2.696212768554688 84.07176208496094 1.5 81 1.5 L 13 1.5 M 13 0 L 81 0 C 88.17970275878906 0 94 5.820289611816406 94 13 L 94 78 C 94 85.17970275878906 88.17970275878906 91 81 91 L 13 91 C 5.820289611816406 91 0 85.17970275878906 0 78 L 0 13 C 0 5.820289611816406 5.820289611816406 0 13 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-flight-land",
    "data-name": "Icon material-flight-land",
    d: "M3.75,45.385H51.121v4.986H3.75ZM21.651,31.1,32.5,33.991l13.239,3.54a3.744,3.744,0,1,0,1.945-7.23L34.442,26.76,27.56,4.272,22.748,3V23.644L10.357,20.328,8.038,14.544l-3.615-.972v12.89l3.989,1.072L21.651,31.1Z",
    transform: "translate(19.151 19)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrival);
export default __webpack_public_path__ + "static/media/arrival.98ab81a1f885960beaa10392acdd9d68.svg";
export { ForwardRef as ReactComponent };